export default __webpack_public_path__ + "static/new-italia-4-b24328707ab8166c2e6bdbb4805e1fdd.jpg";